import React from "react";
import { Link } from "react-router-dom";
import { Reveal } from "../hooks/useReveal";
import { blogPosts } from "../data/blogPosts";

const BlogGrid = ({ title = "From the Journal", subtitle = "Insights on trusts, control, and protection." }) => {
  return (
    <section className="bg-parchment py-24 sm:py-32" data-testid="blog-grid-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <div className="flex items-center gap-3 text-[11px] sm:text-xs tracking-[0.3em] uppercase font-semibold text-gold">
            <span className="h-px w-10 bg-gold/60" />
            Insights
          </div>
          <h2 className="font-display text-3xl sm:text-4xl text-ink tracking-tight leading-[1.06] mt-6">
            {title}
          </h2>
          <p className="text-ink/60 text-base sm:text-lg mt-4 max-w-2xl">{subtitle}</p>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mt-14">
          {blogPosts.map((post, idx) => (
            <Reveal key={post.slug} delay={(idx % 3) * 70}>
              <Link
                to={`/blog/${post.slug}`}
                className="group block bg-white border border-ink/10 rounded-2xl overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-[box-shadow,transform] duration-400 h-full"
                data-testid={`blog-card-${idx}`}
              >
                <div className="h-48 overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    loading="lazy"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                </div>
                <div className="p-6">
                  <h3 className="font-display text-lg text-ink leading-snug group-hover:text-goldeep transition-colors duration-300">
                    {post.title}
                  </h3>
                  <p className="text-ink/60 text-sm leading-relaxed mt-3 line-clamp-3">
                    {post.excerpt}
                  </p>
                  <time className="block text-ink/40 text-xs mt-4 tracking-wide uppercase">
                    {post.date}
                  </time>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogGrid;
